/* ─── THEME.JS — PawLux Shopify Theme ──────────────────────── */

/* ─── NAVBAR SCROLL ────────────────────────────────────────── */
var navbar = document.getElementById('navbar');
if (navbar) {
  window.addEventListener('scroll', function () {
    navbar.classList.toggle('scrolled', window.scrollY > 30);
  });
}

/* ─── MENU BURGER MOBILE ───────────────────────────────────── */
function toggleMenu() {
  var menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.toggle('open');
}

/* ─── TOAST NOTIFICATION ───────────────────────────────────── */
function showToast(title, sub, icon) {
  var toast = document.getElementById('toast');
  if (!toast) return;
  document.getElementById('toastTitle').textContent = title || 'Ajouté au panier !';
  document.getElementById('toastSub').textContent = sub || 'Voir votre panier';
  document.getElementById('toastIcon').textContent = icon || '🛒';
  toast.classList.add('show');
  setTimeout(function () { toast.classList.remove('show'); }, 3200);
}

/* ─── AJAX ADD TO CART ──────────────────────────────────────── */
function addToCartAjax(btn, variantId, productTitle, qty) {
  qty = qty || 1;
  if (btn) {
    btn.disabled = true;
    btn.textContent = '⏳ Ajout...';
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(function (r) { return r.json(); })
  .then(function (data) {
    if (data.status) {
      // Erreur Shopify (ex: épuisé)
      showToast('Erreur', data.description || 'Produit indisponible', '❌');
      if (btn) { btn.disabled = false; btn.textContent = '+ Panier'; }
    } else {
      updateCartCount();
      showToast(
        'Ajouté au panier !',
        (productTitle || data.title) + ' → ' + (data.quantity || qty) + 'x',
        '🛒'
      );
      if (btn) {
        btn.textContent = '✓ Ajouté !';
        btn.style.background = 'var(--forest)';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = '+ Panier';
          btn.style.background = '';
        }, 2000);
      }
    }
  })
  .catch(function (err) {
    console.error('Cart error:', err);
    showToast('Erreur', 'Veuillez réessayer', '❌');
    if (btn) { btn.disabled = false; btn.textContent = '+ Panier'; }
  });
}

/* ─── MISE À JOUR COMPTEUR PANIER ──────────────────────────── */
function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badges = document.querySelectorAll('#cartCount, .cart-badge');
      badges.forEach(function (el) { el.textContent = cart.item_count; });
    });
}

/* ─── WISHLIST (localStorage) ──────────────────────────────── */
function toggleWishlist(btn, productId) {
  var key = 'pawlux_wishlist';
  var wishlist = JSON.parse(localStorage.getItem(key) || '[]');
  var idx = wishlist.indexOf(productId);
  if (idx === -1) {
    wishlist.push(productId);
    btn.textContent = '❤️';
    showToast('Ajouté aux favoris', '', '❤️');
  } else {
    wishlist.splice(idx, 1);
    btn.textContent = '🤍';
  }
  localStorage.setItem(key, JSON.stringify(wishlist));
}

/* Restaurer l'état wishlist au chargement */
(function () {
  var wishlist = JSON.parse(localStorage.getItem('pawlux_wishlist') || '[]');
  wishlist.forEach(function (id) {
    var btn = document.querySelector('[data-wishlist="' + id + '"]');
    if (btn) btn.textContent = '❤️';
  });
})();

/* ─── ANIMATIONS ENTRÉE (Intersection Observer) ────────────── */
var observer = new IntersectionObserver(function (entries) {
  entries.forEach(function (e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      observer.unobserve(e.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.prod-card, .cat-card, .val-card, .testi-card').forEach(function (el) {
  el.classList.add('fade-in');
  observer.observe(el);
});

/* ─── TOAST CLICK → PANIER ─────────────────────────────────── */
var toast = document.getElementById('toast');
if (toast) {
  toast.style.cursor = 'pointer';
  toast.addEventListener('click', function () {
    window.location.href = window.cartUrl || '/cart';
  });
}
